export default "__VITE_ASSET__9250b70d__"